import { useRequest } from 'features/request/useRequest';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

export interface IOptionsUseIsUniqInternalNumber {
    idData: { name: string; value?: number };
    request: { name: string; value: any };
    changedValue: { name: string; value: string | number };
}

export const useIsUniqInternalNumber = (options: IOptionsUseIsUniqInternalNumber): boolean => {
    const dispatch = useDispatch();
    const {
        idData: { name: idName, value: idValue },
        request: { name: requestName, value: requestValue },
        changedValue: { name: changedName, value: changedValue },
    } = options;

    const variables = useMemo(
        () => ({
            [changedName]: changedValue,
            [idName]: idValue || null,
        }),
        [changedName, changedValue, idName, idValue],
    );

    const [data, , , makeRequest] = useRequest({
        requestId: requestName,
        query: requestValue,
        variables,
        withEffect: false,
    });

    const debounceSetSearchValue = useDebounce(() => {
        if (requestValue && changedValue) {
            dispatch(makeRequest(variables));
        }
    }, 500);

    useEffect(() => debounceSetSearchValue(), [debounceSetSearchValue, changedValue]);

    // @ts-ignore
    return data?.[requestName]?.result;
};
